import { globalGetService } from '@/utils/globalApiServices';
import { CnpItem, RcsCnp } from './types';

export const getCnpList = async (
  params: {
    countryCode?: string;
    channelId?: string;
    soleProprietorEnabled?: boolean;
    cnpMigrationSupported?: boolean;
  } = {}
): Promise<CnpItem[]> => {
  const response = await globalGetService('csp/cnp', params);
  return response?.ok ? response.data : [];
};

export const getRcsCnps = async () => {
  const data = [
    {
      id: 'dca0',
      name: 'Demo DCA',
    },
    {
      id: 'dca1',
      name: 'DCA 1',
    },
    {
      id: 'dca2',
      name: 'DCA 2',
    },
  ];
  return data as RcsCnp[];
};
